import { Link } from 'react-router-dom';
import type { Comic } from '@/mocks/comics';

interface ComicCardProps {
  comic: Comic;
  size?: 'normal' | 'large';
}

export default function ComicCard({ comic, size = 'normal' }: ComicCardProps) {
  return (
    <Link
      to={`/comic/${comic.id}`}
      className="group block"
    >
      <div className={`relative overflow-hidden rounded-lg ${
        size === 'large' ? 'aspect-[3/4]' : 'aspect-[3/4]'
      }`}>
        <img
          src={comic.coverImage}
          alt={comic.title}
          title={`${comic.title} - 韩国漫画免费在线观看`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
          loading="lazy"
        />
        <div className="absolute inset-0 bg-gradient-to-t from-background-950/90 via-transparent to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300" />
        <div className="absolute bottom-0 left-0 right-0 p-3 translate-y-full group-hover:translate-y-0 transition-transform duration-300">
          <span className="inline-block text-xs bg-primary-500 text-background-950 px-2 py-0.5 rounded-full font-medium whitespace-nowrap">
            {comic.status}
          </span>
        </div>
        {comic.isHot && (
          <span className="absolute top-2 left-2 bg-accent-500 text-background-950 text-[10px] px-1.5 py-0.5 rounded font-semibold whitespace-nowrap">
            HOT
          </span>
        )}
        {comic.isRecommended && (
          <span className="absolute top-2 right-2 bg-primary-500/90 text-background-950 text-[10px] px-1.5 py-0.5 rounded font-semibold whitespace-nowrap">
            推荐
          </span>
        )}
      </div>
      <div className="mt-2.5 px-0.5">
        <h3 className="text-sm font-medium text-foreground-100 group-hover:text-primary-400 transition-colors line-clamp-1">
          {comic.title}
        </h3>
        <div className="flex items-center gap-2 mt-1">
          <span className="text-xs text-foreground-400">{comic.author}</span>
          <span className="text-foreground-600 text-[10px]">·</span>
          <span className="text-xs text-foreground-500">{comic.latestChapter}</span>
        </div>
        <div className="flex items-center gap-2 mt-1">
          <div className="flex items-center gap-0.5">
            <div className="w-3.5 h-3.5 flex items-center justify-center">
              <i className="ri-star-fill text-accent-500 text-xs"></i>
            </div>
            <span className="text-xs text-accent-500 font-medium">{comic.rating}</span>
          </div>
          <span className="text-foreground-600 text-[10px]">·</span>
          <span className="text-xs text-foreground-500">{formatViews(comic.views)}</span>
        </div>
      </div>
    </Link>
  );
}

export function formatViews(views: number): string {
  if (views >= 1000000) return `${(views / 1000000).toFixed(1)}M`;
  if (views >= 10000) return `${(views / 10000).toFixed(1)}万`;
  return views.toString();
}